import { IonActionSheet, IonBadge, IonButton, IonIcon, IonItem, IonSearchbar } from "@ionic/react";
import { isNativeIos, useIsMobileView } from "frontend-lib/Utils/Mobile";
import React, { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CTA from "../../Constants";
import { Input, Radio, Row, Select } from "antd";
import { useAppContext } from "State/Global/AppContext";
import styles from "./ChatList.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faComments,
    faFilter,
    faRobot,
    faTimesCircle,
    faUser,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import IonOptiModal from "Components/IonOptiModal";
import IonFiltersMobile from "Components/IonFiltersMobile";
import { filterOutline, chevronDownOutline } from "ionicons/icons";
import { headerBackgroundColor } from "Styles/MobileColors";

const {
    newDot,
    filterContainer,
    filtersContainer,
    searchInputWrapper,
    filtersDropdownButton,
    filtersCountStyles,
} = styles;
const { Search } = Input;

interface ChatListFilterHeadersProps {
    showFilter: string;
    searchInputVal: string;
    isDropdownFilterVisible: boolean;
    filtersCount: number | null;
    handleStatusChangeCb: (value: string) => void;
    handleParticipantChangeCb: (value: string) => void;
    handleSearchInputCb: (value: string) => void;
    showMoreFiltersClickCb: () => void;
    filters: any;
    handlers: any;
    chatListState: any;
}

const { Option } = Select;

export default function ChatListFilterHeaders({
    showFilter,
    searchInputVal,
    isDropdownFilterVisible,
    filtersCount,
    handleStatusChangeCb,
    handleParticipantChangeCb,
    handleSearchInputCb,
    showMoreFiltersClickCb,
    filters,
    handlers,
    chatListState,
}: ChatListFilterHeadersProps) {
    //@ts-ignore
    const { appState } = useAppContext();
    const { t } = useTranslation();
    const [statusFilter, setStatusFilter] = useState(CTA.FILTERS.ACTIVE);
    const searchInputRef = useRef(null);
    const [isStatusFilterOpen, setIsStatusFilterOpen] = useState(false);

    const currentUserIsAdmin = useMemo(() => {
        return appState.agent?.isAdmin;
    }, [appState.agent?.isAdmin]);

    const hideAgentsTabForNonAdminUsers = useMemo(() => {
        return (
            appState.workspaceConfig?.agent?.hideAgentsTabForNonAdminUsers && !currentUserIsAdmin
        );
    }, [appState.workspaceConfig?.agent?.hideAgentsTabForNonAdminUsers, currentUserIsAdmin]);
    const [INM] = useIsMobileView();

    const radioGroupStyle: React.CSSProperties = INM
        ? {
              display: "flex",
              justifyContent: "space-evenly",
              marginLeft: "auto",
              height: "3.2rem",
          }
        : {
              marginLeft: "auto",
              display: "flex",
              justifyContent: "space-evenly",
              width: "100%",
          };
    const radioButtonStyle: React.CSSProperties = INM
        ? {
              height: "110%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              alignItems: "center",
              backgroundColor: headerBackgroundColor,
          }
        : {
              minWidth: "20%",
              textAlign: "center",
          };

    const buttonContainerStyle: React.CSSProperties = INM
        ? {
              ...radioButtonStyle,
              padding: ".25rem",
              borderBottom: undefined,
              backgroundColor: undefined,
              boxShadow: undefined,
          }
        : {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
          };

    const renderFilterStatusMobile = () => {
        return (
            <div style={{ display: "flex", alignItems: "center" }}>
                <IonSearchbar
                    animated
                    onIonChange={(e) => handleSearchInputCb(e.detail.value || "")}
                    placeholder={t("filters.search")}
                ></IonSearchbar>
                <IonButton id="open-filters-modal">
                    <IonIcon icon={filterOutline} />
                    {filtersCount && filtersCount > 0 ? (
                        <IonBadge style={{ position: "absolute", top: 0, right: -20 }}>
                            {filtersCount}
                        </IonBadge>
                    ) : (
                        <></>
                    )}
                </IonButton>
                <IonOptiModal trigger="open-filters-modal" title={t("filters.filters")}>
                    <IonFiltersMobile
                        filters={filters}
                        handlers={handlers}
                        chatListState={chatListState}
                    />
                </IonOptiModal>
                <IonActionSheet
                    cssClass={isNativeIos() ? "optiwe-action-sheet" : ""}
                    header={t("filters.filterStatusHeader")}
                    isOpen={isStatusFilterOpen}
                    onDidDismiss={({ detail }) => {
                        detail.data?.actionCb();
                        setIsStatusFilterOpen(false);
                    }}
                    buttons={[
                        {
                            text: t("filters.active"),
                            data: {
                                actionCb: () => {
                                    setStatusFilter(CTA.FILTERS.ACTIVE);
                                    handleStatusChangeCb(CTA.FILTERS.ACTIVE);
                                },
                            },
                        },
                        {
                            text: t("filters.init_by_agent"),
                            data: {
                                actionCb: () => {
                                    setStatusFilter(CTA.FILTERS.INIT_BY_AGENT);
                                    handleStatusChangeCb(CTA.FILTERS.INIT_BY_AGENT);
                                },
                            },
                        },
                        {
                            text: t("filters.closed"),
                            data: {
                                actionCb: () => {
                                    setStatusFilter(CTA.FILTERS.ENDED);
                                    handleStatusChangeCb(CTA.FILTERS.ENDED);
                                },
                            },
                        },
                    ]}
                />
            </div>
        );
    };

    return (
        <>
            <div
                className={INM ? undefined : filterContainer}
                style={{
                    backgroundColor: INM ? headerBackgroundColor : undefined,
                }}
            >
                {INM ? renderFilterStatusMobile() : <></>}
                <Radio.Group
                    style={radioGroupStyle}
                    value={showFilter}
                    size="small"
                    onChange={(e) => handleParticipantChangeCb(e.target.value)}
                    disabled={filters.searchText}
                >
                    <Radio.Button value={CTA.FILTERS.ME} style={radioButtonStyle}>
                        <div style={buttonContainerStyle}>
                            {/* @ts-ignore */}
                            {INM && <FontAwesomeIcon icon={faUser} size="2x" />}
                            {t("filters.me")}
                            {appState.newChats && (
                                <div
                                    style={
                                        INM
                                            ? { marginTop: "-3.5rem", marginLeft: "3rem" }
                                            : undefined
                                    }
                                >
                                    <span className={newDot} />
                                </div>
                            )}
                        </div>
                    </Radio.Button>
                    <Radio.Button value={CTA.FILTERS.UNASSIGNED} style={radioButtonStyle}>
                        <div style={buttonContainerStyle}>
                            {/* @ts-ignore */}
                            {INM && <FontAwesomeIcon icon={faComments} size="2x" />}
                            <span>{t("filters.unassigned")}</span>
                        </div>
                    </Radio.Button>
                    {!hideAgentsTabForNonAdminUsers && (
                        <Radio.Button value={CTA.FILTERS.ALL} style={radioButtonStyle}>
                            <div style={buttonContainerStyle}>
                                {/* @ts-ignore */}
                                {INM && <FontAwesomeIcon icon={faUsers} size="2x" />}
                                {t("filters.agents")}
                            </div>
                        </Radio.Button>
                    )}
                    <Radio.Button value={CTA.FILTERS.AI_AGENTS} style={radioButtonStyle}>
                        <div style={buttonContainerStyle}>
                            {/* @ts-ignore */}
                            {INM && <FontAwesomeIcon icon={faRobot} size="2x" />}
                            {t("filters.bot")}
                        </div>
                    </Radio.Button>
                </Radio.Group>
            </div>
            {!INM ? (
                <div className={filtersContainer}>
                    <div className={searchInputWrapper}>
                        <div style={{ width: "100%" }}>
                            <Search
                                allowClear
                                value={searchInputVal}
                                onChange={(e) => handleSearchInputCb(e.target.value)}
                                ref={searchInputRef}
                                placeholder={t("filters.search")}
                            />
                        </div>
                    </div>
                    <button onClick={showMoreFiltersClickCb} className={filtersDropdownButton}>
                        <span>{t("filters.filters")} </span>
                        {filtersCount && filtersCount > 0 && !isDropdownFilterVisible ? (
                            <span className={filtersCountStyles}>{filtersCount}</span>
                        ) : (
                            <FontAwesomeIcon
                                /* 
                            @ts-ignore */
                                icon={isDropdownFilterVisible ? faTimesCircle : faFilter}
                                style={{
                                    fontSize: "15px",
                                    width: "10px",
                                    position: "relative",
                                    top: "1px",
                                    marginLeft: "5px",
                                    color: isDropdownFilterVisible ? "#FD6A56" : "#BFBFBF",
                                }}
                            />
                        )}
                    </button>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
